// default
import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import {
    ApiGateway,
    AttendanceEditProvider,
    Currency,
    DegreeParticipation,
    DegreeParticipationListProvider,
    FirmListProvider,
    Order,
    OrderPayEditProvider,
    ParameterProvider,
    Performer,
    Professional,
    Speciality,
} from "cw-backend";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";
import { Procedure } from "../../../../../../../../../shared/cw-backend/models/accreditation/procedure";
import { AttendanceListProvider } from "../../../../../../../../../shared/cw-backend/providers/attendance/attendance/attendance-list.provider";
import { PageOptions } from "../../../../../../../../../shared/cw-backend/util/page";

import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { fuseAnimations } from "@fuse/animations";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { AttendanceMaterialComponent } from "app/layout/components/attendance-material/attendance-material.component";
import { RequireMatch } from "app/validators/requireMatch";
import { CwUtils, SnackBarService } from "cw-utils";
import moment from "moment";
import { Subject } from "rxjs";
import { ParameterTO } from "../../../../../../../../../shared/cw-backend/models/application/parameter/parameter";
import { ParameterNameEnum } from "../../../../../../../../../shared/cw-backend/models/application/parameter/parameter-name-enum.enum";
import { QuickRegistrationSolicComponent } from "../quick-registration-solic/quick-registration-solic.component";

export class OrderItem {
    id?: number;
    name?: string;
    order: Pick<Order, "id">;
    procedure?: Pick<Procedure, "id">;
    performer?: Pick<Performer, "id">;
    performerAccredited?: Pick<Performer, "id">;
    professional?: any;
    firm?: any;
    professionalAnesthetist?: Pick<Professional, "id">;
    speciality?: Pick<Speciality, "id">;
    sequence?: number;
    code?: string;
    date?: string;
    examDate?: string;
    hour?: Date;
    hourend?: Date;
    currency?: Currency;
    value?: number;
    amount?: number;
    quantity?: number;
    discount?: number;
    discountType?: string;
    total?: number;
    ucoValue?: number;
    portValue?: number;
    filmValue?: number;
    participationType?: string;
    participationValue?: number;
    participationValueFilm?: number;
    participationTypeFilm?: string;
    kitList?: any;
    orderItemFeeList? = new Array<any>();
    orderItemProductList? = new Array<any>();
    orderItemAuxiliaryList? = new Array<any>();
    orderItemTiss?: any;
    session?: any;
    userCreated?: string;
    userUpdated?: string;
}

export class OrderItemTiss {
    id?: number;
    viaAccess?: ViaAccess;
    viaAdministration?: ViaAdministration;
    technique?: string;
    orderItem?: OrderItem;
    token?: string;
    tokenStatus?: string;
    degreeParticipation?: DegreeParticipation;
    location?: string;
    nightShift?: boolean;
    reductionAddition?: number;
}

export class ViaAccess {
    name?: string;
    id: number;
    code?: string;
}

export class ViaAdministration {
    name?: string;
    id: number;
    code?: string;
}

@Component({
    selector: "os-items",
    templateUrl: "./os-items.component.html",
    styleUrls: ["./os-items.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class OsItemsComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input()
    order: Order;

    @Input()
    orderItem: OrderItem;

    @Input()
    subscription: any;

    @Input()
    costCenterList: any[];

    @Input("ControlSessionByParameterSystem")
    ControlSessionByParameterSystem: boolean = false;

    @Output()
    emitUpdate: EventEmitter<boolean> = new EventEmitter();

    @Output()
    emitAction: EventEmitter<string> = new EventEmitter();

    @ViewChild("attendanceMaterialOrder")
    attendanceMaterial: AttendanceMaterialComponent;

    private _insurance: any;
    procedure: Procedure = new Procedure();
    feeAccreditationList: any;
    materialKitList: any;
    drugKitList: any;
    opmeKitList: any;
    auxiliaryList: any;
    kitList: any = [];
    orderItemFeeList: any = [];
    orderItemProductList: any = [];
    orderItemProductListM: any[] = [];
    orderItemAuxiliaryList: any[] = [];
    accreditationKitList = new Array();

    degreeParticipationList: DegreeParticipation[];

    viewModeDadosAdicionais: boolean = false;

    loading = true;

    @Input()
    public set insurance(insurance: any) {
        this._insurance = insurance;
        // this.getPerformerByInsurance();
        // this.getProcedureListByInsurance();
    }

    public get insurance(): any {
        return this._insurance;
    }

    @Output() orderItemAdd: EventEmitter<OrderItem> = new EventEmitter();

    private _unsubscribeAll: Subject<any>;
    solicRegistrationDialogRef: MatDialogRef<QuickRegistrationSolicComponent>;

    //Listas
    performerList: any[];
    performeAccreditationList: any[];
    specialistyList: any[];
    profissionalList: any[];
    procedureList: Procedure[];
    viaAdministration: any[] = [];
    viaAccess: any[] = [];
    firmList: any[];

    //var
    professional: any;
    tipoSolicitante: string = "";
    actionString: string;
    progress: boolean = false;
    isProcedure: boolean = true;
    discountLoading: boolean = false;
    disableDeleteOrderPay: boolean = false;
    showAttendanceMaterial: boolean = true;
    //controle de sessão
    sessionView: boolean = false;
    serviceFrequencyPerWeek: String = "0";
    quatitySessionCurrent: number = 0;
    ControlSessionByParameterProcedure: boolean = false;
    session: any;

    //Formularios
    itemOsForm: FormGroup;
    dadosAdicionaisForm: FormGroup;
    discountControl = new FormControl(0);
    userCreatedControl = new FormControl("");
    userUpdatedControl = new FormControl("");

    //page Options
    professionalPageOptions: PageOptions;
    performerPageOptions: PageOptions;
    performerAccreditationPageOptions: PageOptions;
    specialityPageOptions: PageOptions;
    insurancePgaeOptions: PageOptions;
    procedurePageOptions: PageOptions;
    firmPageOptions: PageOptions;

    kitOrderItem = new Array();

    type: string = "1";

    constructor(
        private _formBuilder: FormBuilder,
        private attendanceListProvider: AttendanceListProvider,
        private parameterProvider: ParameterProvider,
        private attendanceEditProvider: AttendanceEditProvider,
        private firmListProvider: FirmListProvider,
        private orderPayEditProvider: OrderPayEditProvider,
        private degreeParticipationListProvider: DegreeParticipationListProvider,
        public gw: ApiGateway,
        private snackBar: SnackBarService,
        public dialog: MatDialog
    ) {
        this._unsubscribeAll = new Subject();
        this.professionalPageOptions = new PageOptions();
        this.professionalPageOptions.fieldSort = "person.name";
        this.professionalPageOptions.sizePage = 15;

        this.performerPageOptions = new PageOptions();
        this.performerPageOptions.fieldSort = "professional.person.name";
        this.performerPageOptions.sizePage = 15;

        this.performerAccreditationPageOptions = new PageOptions();
        this.performerAccreditationPageOptions.fieldSort = "professional.person.name";
        this.performerAccreditationPageOptions.sizePage = 15;

        this.firmPageOptions = new PageOptions();
        this.firmPageOptions.sizePage = 15;

        this.specialityPageOptions = new PageOptions();
        this.specialityPageOptions.fieldSort = "speciality.name";
        this.specialityPageOptions.sizePage = 15;

        this.insurancePgaeOptions = new PageOptions();
        this.insurancePgaeOptions.sizePage = 15;

        this.procedurePageOptions = new PageOptions();
        this.procedurePageOptions.sizePage = 15;
    }

    async ngOnInit(): Promise<void> {
        this.itemOsForm = this.createItemOsForm();
        this.dadosAdicionaisForm = this.createDadosAdicionaisForm();
        await this.getOrderItemId();
        this.getProfessionalList();
        this.getPerformerAccreditedList();
        this.getFirmList();
        this.getViaAccess();
        this.getViaAdministration();
        this.getDegreeParticipation();
        this.filterProfessional();
        this.filterFirm();
        // this.setItemOs();
        this.filterProcedure();
        this.filterPerformer();
        this.filterPerformerAccredited();
        this.observableQuantity();
        this.getPerformerByInsurance();
        this.getProcedureListByInsurance();
        this.defaultValues();
        setTimeout(() => {
            // this.initKite();
            this.getState(this.order.state);
        }, 300);
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
        this.action("back");
    }

    ngAfterViewInit() {
        this.getState(this.order.state);
        this.getStatus(this.order.status);
    }

    displaySimpleFn(object?: any): string | undefined {
        if (object && object.name) {
            return object.name;
        } else if (object && object.tableName) {
            return object.tableName;
        } else {
            return "";
        }
    }

    compareSelect(o1: any, o2: any): boolean {
        if (o1 == null || o2 == null) {
            return null;
        }
        return o1.id === o2.id;
    }

    displayPerformerFn(performer?: any): string | undefined {
        if (!performer) {
            return "";
        }
        if (performer.professional) {
            return performer.professional.person.name;
        }
        return performer.person.name;
    }

    displayFirmFn(firm?: any): string | undefined {
        if (!firm) {
            return "";
        }
        return firm.name ? firm.name : "";
    }

    initKite() {
        this.kitOrderItem = [];
        this.attendanceMaterial.iOrder = this.order;
        if (this.orderItem.orderItemFeeList) {
            this.kitOrderItem = this.kitOrderItem.concat(
                this.orderItem.orderItemFeeList
            );
        }
        if (this.orderItem.orderItemProductList) {
            this.kitOrderItem = this.kitOrderItem.concat(
                this.orderItem.orderItemProductList
            );
        }
        if (this.orderItem.orderItemAuxiliaryList) {
            this.kitOrderItem = this.kitOrderItem.concat(
                this.orderItem.orderItemAuxiliaryList
            );
        }

        this.attendanceMaterial.setAccreditationProcedureKit(
            this.kitOrderItem,
            this.insurance,
            this.order
        );
    }

    //filtro profissional solicitante
    filterProfessional() {
        this.itemOsForm.controls["profissionalRequest"].valueChanges
            .pipe(
                takeUntil(this.subscription),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                this.filterMethodProfessional(res);
                this.getProfessionalList();
            });
    }

    filterFirm() {
        this.itemOsForm.controls["firm"].valueChanges
            .pipe(
                takeUntil(this.subscription),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                let filter = "";
                if (typeof res == "string") {
                    filter = res;
                }
                this.firmPageOptions.argument = filter;
                this.getFirmList();
            });
    }

    filterMethodProfessional(res) {
        if (res && res.id) {
            this.professionalPageOptions.argument = res.name;
        } else if (res) {
            this.professionalPageOptions.argument = res;
        } else {
            this.professionalPageOptions.argument = "";
            this.itemOsForm.controls["profissionalRequest"].setValue(null);
        }
    }

    filterPerformer() {
        this.itemOsForm.controls["professional"].valueChanges
            .pipe(
                takeUntil(this.subscription),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                if (res && res.id) {
                    this.performerPageOptions.argument =
                        res.professional.person.name;
                    this.getProcedureListByInsurance(res.id);
                } else if (res && typeof res === "string") {
                    this.performerPageOptions.argument = res;
                } else {
                    this.getProcedureListByInsurance();
                    this.performerPageOptions.argument = "";
                    this.itemOsForm.controls["professional"].setValue(null);
                }
                this.getPerformerByInsurance();
            });
    }

    filterPerformerAccredited() {
        this.itemOsForm.controls["credentiatedProfessional"].valueChanges
            .pipe(
                takeUntil(this.subscription),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                let filter = "";
                if (res && typeof res === "string") {
                    filter = res;
                }

                this.performerAccreditationPageOptions.argument = filter;
                this.getPerformerAccreditedList();
            });
    }

    //procedure
    filterProcedure() {
        this.itemOsForm.controls["description"].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                if (res && res.name) {
                    this.procedurePageOptions.argument = res.name;
                    this.getParameterValue(
                        ParameterNameEnum.PROCEDURE_ACCEPT_SESSION,
                        String(res.id)
                    );
                } else if (res) {
                    this.procedurePageOptions.argument = res;
                } else {
                    this.procedurePageOptions.argument = "";
                }
                this.getProcedureListByInsurance();
            });
    }

    observableQuantity() {
        this.itemOsForm.controls["quantity"].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(300),
                distinctUntilChanged()
            )
            .subscribe({
                next: async (res) => {
                    if (res > 1) {
                        if (this.sessionView == false) {
                            if (
                                this.ControlSessionByParameterProcedure == true
                            ) {
                                this.sessionView = true;
                            }
                            if (
                                this.ControlSessionByParameterProcedure ==
                                false &&
                                this.ControlSessionByParameterSystem == true
                            ) {
                                await this.dialogShowSession();
                            }
                        }
                    } else {
                        this.sessionView = false;
                    }
                    this.quatitySessionCurrent = res;
                },
            });
    }

    async dialogShowSession() {
        return new Promise((resolve, reject) => {
            const dialog = this.dialog.open(FuseConfirmDialogComponent);

            dialog.componentInstance.action = "Lançar como sessão?";

            dialog
                .afterClosed()
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe({
                    next: (res) => {
                        if (res) {
                            if (res == true) {
                                this.sessionView = true;
                            } else {
                                this.sessionView = false;
                            }
                            resolve(true);
                        } else {
                            reject(true);
                        }
                    },
                });
        });
    }

    async getParameterValueByNames(names, key?) {
        this.parameterProvider
            .getParameterValueByKeyAndNames(key, names)
            .then((res) => {
                let parameterList: Array<ParameterTO> = res.body;
                parameterList.forEach((element: ParameterTO) => {
                    switch (element.name) {
                        case "ACCREDITATION_PROFESSIONAL_SOLIC":
                            if (CwUtils.checkStringIsNotNull(element.value)) {
                                this.getProfessionalById(element.value);
                            }
                            break;
                        case "VIA_ACCESS_ACCREDITATION":
                            if (CwUtils.checkStringIsNotNull(element.value)) {
                                this.dadosAdicionaisForm.controls['viaAccess'].setValue(this.viaAccess.find(via => via?.id == Number(element?.value)));
                            }
                            break;

                        default:
                            break;
                    }
                });

                if (this.quatitySessionCurrent > 1) {
                    this.sessionView = this.ControlSessionByParameterSystem
                        ? this.ControlSessionByParameterSystem
                        : this.ControlSessionByParameterProcedure;
                }
            })
            .catch((err) => { });

    }

    async getParameterValue(name, key?) {
        if (key) {
            this.parameterProvider
                .getValueByParameterOrParameterValueParameter(name, key)
                .then((res) => {
                    if (res.body == "0") {
                        if (key) {
                            this.ControlSessionByParameterProcedure = false;
                        } else {
                            this.ControlSessionByParameterSystem = false;
                        }
                    } else {
                        if (key) {
                            this.ControlSessionByParameterProcedure = true;
                        } else {
                            this.ControlSessionByParameterSystem = true;
                        }
                    }

                    if (this.quatitySessionCurrent > 1) {
                        this.sessionView = this.ControlSessionByParameterSystem
                            ? this.ControlSessionByParameterSystem
                            : this.ControlSessionByParameterProcedure;
                    }
                })
                .catch((err) => { });
        } else {
            this.parameterProvider.getByName(name).then((res) => {
                const value = res.body.value;
                if (value == "0") {
                    this.ControlSessionByParameterSystem = false;
                } else {
                    this.ControlSessionByParameterSystem = true;
                }
            });
        }
    }

    getProfessionalList() {
        this.attendanceListProvider
            .getProfessional(this.professionalPageOptions)
            .then((res) => {
                this.profissionalList = res.body.content;
            });
    }

    //busca por medico solicitante por id
    getProfessionalById(professionalId) {
        this.attendanceListProvider.getProfessionalById(
            professionalId
        ).then((res) => {
            this.itemOsForm.controls['profissionalRequest'].setValue(res.body);
            this.setSolic(res.body);
        });
    }

    //Buscar Firma
    getFirmList() {
        this.firmListProvider
            .getPageToOrder(this.firmPageOptions)
            .then((res) => {
                this.firmList = res.body.content;
            });
    }

    getDegreeParticipation() {
        this.degreeParticipationListProvider.getAll().then((res) => {
            this.degreeParticipationList = res.body;
        });
    }

    createItemOsForm(): FormGroup {
        let date = new Date();

        return this._formBuilder.group({
            launcherType: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
                Validators.required,
            ],
            dateItemOs: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
                Validators.required,
            ],
            resultCenterItemOs: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
                Validators.required,
            ],
            profissionalRequest: [null],
            firm: [null],
            credentiatedProfessional: [null, Validators.required],
            professional: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
                Validators.required,
            ],
            description: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
                [Validators.required, RequireMatch.bind(this)],
            ],
            speciality: [Validators.required],
            procedureValue: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
                Validators.required,
            ],
            procedureCode: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
                Validators.required,
            ],
            total: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
            ],
            professionalAnesthetist: [null],
            hour: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
                Validators.required,
            ],
            hourend: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
                Validators.required,
            ],
            quantity: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
                Validators.required,
            ],
            sequence: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
                Validators.required,
            ],
            unidade: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
                Validators.required,
            ],
            tipoSolicitante: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
            ],
            discount: [{ value: null, disabled: true }, Validators.required],
            participationValue: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
            ],
            participationType: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
            ],
            participationValueFilm: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
            ],
            participationTypeFilm: [
                {
                    value: null,
                    disabled: this.checkStatus() == false ? true : false,
                },
            ],
        });
    }

    createDadosAdicionaisForm(): FormGroup {
        return this._formBuilder.group({
            id: [null],
            orderItem: [],
            viaAccess: [null],
            viaAdministration: [null],
            technique: [null],
            token: [null],
            tokenStatus: [null],
            degreeParticipation: [null],
            location: ["N"],
            nightShift: [false],
            reductionAddition: [null],
        });
    }

    applyDiscount() {
        if (this.order.state === "") {
        }

        if (this.discountLoading == true) {
            return;
        }
        this.discountLoading = true;
        let applyDiscount = {
            orderId: this.order.id,
            orderItemId: this.orderItem?.id,
            type: this.type,
            valueDiscount:
                this.discountControl.value == null
                    ? 0
                    : this.discountControl.value,
        };

        this.orderPayEditProvider
            .applyDiscount(applyDiscount)
            .then((res) => {
                this.discountLoading = false;
                this.snackBar.successMessage("Desconto Aplicado!");
                this.emitUpdate.emit(true);
                this.getOrderItemId();
            })
            .catch((err) => {
                this.discountLoading = false;
            });

        setTimeout(() => {
            this.discountLoading = false;
        }, 3000);
    }

    async getOrderItemId() {
        this.loading = true;
        if (this.orderItem?.id == null) {
            this.setItemOs();
            this.loading = false;
            return;
        }
        return new Promise<any>((resolve, reject) => {
            this.attendanceListProvider
                .getOrderItemById(this.orderItem?.id)
                .then((res) => {
                    this.orderItem = res;
                    this.userCreatedControl.setValue(this.orderItem.userCreated)
                    this.userUpdatedControl.setValue(this.orderItem.userUpdated)
                    this.setItemOs();
                    this.loading = false;
                    setTimeout(() => {
                        this.destroyAndRecreateComponent();
                    }, 300);
                    resolve(true);
                })

                .catch((err) => {
                    reject(err);
                });
        });
    }

    setItemOs() {
        this.kitList = [];
        this.accreditationKitList = [];
        this.feeAccreditationList = [];
        this.materialKitList = [];
        this.drugKitList = [];
        this.opmeKitList = [];
        this.auxiliaryList = [];
        if (this.orderItem && this.orderItem.id) {
            if (this.orderItem.orderItemFeeList) {
                this.orderItemFeeList = [];
                this.orderItem.orderItemFeeList.forEach((fee) => {
                    delete fee.orderItem;
                    this.orderItemFeeList.push(fee);
                    this.kitList.push(fee);
                    this.accreditationKitList.push(fee);
                });
            }
            if (this.orderItem.orderItemProductList) {
                this.orderItemProductList = [];
                this.orderItem.orderItemProductList.forEach((product) => {
                    delete product.order;
                    delete product.orderItem;
                    /*delete product.amount;
                    delete product.code;
                    delete product.date;
                    delete product.isSpend;
                    delete product.name;
                    delete product.sequence;
                    delete product.total;
                    delete product.valueSpend;*/

                    this.orderItemProductList.push(product);
                    this.kitList.push(product);
                    this.accreditationKitList.push(product);
                });
            }
            if (this.orderItem.orderItemAuxiliaryList) {
                this.orderItemAuxiliaryList = [];
                this.orderItem.orderItemAuxiliaryList.forEach((auxiliary) => {
                    this.kitList.push(auxiliary);
                    this.accreditationKitList.push(auxiliary);
                });
            }

            this.itemOsForm.controls["hour"].setValue(this.orderItem.hour);
            this.itemOsForm.controls["hourend"].setValue(
                this.orderItem.hourend
            );
            this.itemOsForm.controls["description"].setValue(
                this.orderItem.procedure
            );
            this.itemOsForm.controls["procedureCode"].setValue(
                this.orderItem.code
            );
            this.itemOsForm.controls["procedureValue"].setValue(
                this.orderItem.amount
            );
            this.itemOsForm.controls["quantity"].setValue(
                this.orderItem.quantity
            );
            this.itemOsForm.controls["total"].setValue(this.orderItem.total);

            this.itemOsForm.controls["professional"].setValue(
                this.orderItem.performer
            );
            this.itemOsForm.controls["credentiatedProfessional"].setValue(
                this.orderItem.performerAccredited
            );
            this.itemOsForm.controls["profissionalRequest"].setValue(
                this.orderItem.professional
            );
            this.itemOsForm.controls["firm"].setValue(this.orderItem.firm);
            this.itemOsForm.controls["professionalAnesthetist"].setValue(
                this.orderItem.professionalAnesthetist
            );

            this.itemOsForm.controls["participationValue"].setValue(
                this.orderItem.participationValue
            );
            this.itemOsForm.controls["participationType"].setValue(
                this.orderItem.participationType
            );
            this.itemOsForm.controls["participationValueFilm"].setValue(
                this.orderItem.participationValueFilm
            );
            this.itemOsForm.controls["participationTypeFilm"].setValue(
                this.orderItem.participationTypeFilm
            );

            this.itemOsForm.controls["speciality"].setValue(
                this.orderItem.speciality
            );
            this.itemOsForm.controls["dateItemOs"].setValue(
                this.orderItem.date
            );
            this.itemOsForm.controls["discount"].setValue(
                this.orderItem.discount
            );
            if (this.orderItem.orderItemTiss) {
                this.dadosAdicionaisForm
                    .controls["viaAccess"]
                    .setValue(
                        this.orderItem.orderItemTiss?.viaAccess
                    );
                this.dadosAdicionaisForm
                    .get("viaAdministration")
                    .setValue(this.orderItem.orderItemTiss?.viaAdministration);
                this.dadosAdicionaisForm
                    .get("technique")
                    .setValue(this.orderItem.orderItemTiss?.technique);
                this.dadosAdicionaisForm
                    .get("id")
                    .setValue(this.orderItem.orderItemTiss?.id);
                this.dadosAdicionaisForm
                    .get("token")
                    .setValue(this.orderItem.orderItemTiss?.token);
                this.dadosAdicionaisForm
                    .get("tokenStatus")
                    .setValue(this.orderItem.orderItemTiss?.tokenStatus);
                this.dadosAdicionaisForm
                    .get("orderItem")
                    .setValue(CwUtils.extractId(this.orderItem));
                this.dadosAdicionaisForm
                    .get("degreeParticipation")
                    .setValue(this.orderItem.orderItemTiss.degreeParticipation);
                this.dadosAdicionaisForm
                    .get("location")
                    .setValue(this.orderItem.orderItemTiss?.location);
                this.dadosAdicionaisForm
                    .get("nightShift")
                    .setValue(this.orderItem.orderItemTiss?.nightShift);
                this.dadosAdicionaisForm
                    .get("reductionAddition")
                    .setValue(this.orderItem.orderItemTiss?.reductionAddition);

                if (this.checkStatus() == false) {
                    this.dadosAdicionaisForm.controls["viaAccess"].disable();
                    this.dadosAdicionaisForm.controls["location"].disable();
                    this.dadosAdicionaisForm.controls["nightShift"].disable();
                }
            }

            this.getSpeciality(this.orderItem.performer);
            this.setSolic(this.orderItem?.professional);
            this.getMaMet(this.orderItem.procedure.id);
        } else {
            moment().locale("pt-br");
            this.itemOsForm.controls["dateItemOs"].setValue(moment());
            this.itemOsForm.controls["discount"].setValue(0);
            //const currentHours = new Date().toTimeString('pt-br');

            this.itemOsForm.controls["hour"].setValue(moment().format("LTS"));
            this.itemOsForm.controls["hourend"].setValue(
                moment().add(30, "minute").format("LTS")
            );
        }

        if (!this.checkStatus()) {
            this.disableDeleteOrderPay = true;
        }
    }

    getPerformerByInsurance(procedure?) {
        //  if (this.insurance.id != undefined) {
        //      this.attendanceListProvider
        //          .getPerformer(this.performerPageOptions, this.insurance.id, "")
        //          .then((res) => {
        //              this.performerList = res.body.content;
        //          });
        //  }
        if (this.insurance && this.insurance.id) {
            this.attendanceListProvider
                .getPerformer(
                    this.performerPageOptions,
                    this.insurance.id,
                    procedure || ""
                )
                .then((res) => {
                    this.performerList = res.body.content;
                })
                .catch((erro) => { });
        }
    }

    getPerformerAccreditedList() {
        this.attendanceListProvider
            .getPerformer(
                this.performerAccreditationPageOptions,
                null,
                ""
            )
            .then((res) => {
                this.performeAccreditationList = res.body.content;
            })
            .catch((erro) => { });
    }

    getProcedureListByInsurance(performer?) {
        if (!performer) {
            if (this.itemOsForm instanceof FormGroup) {
                performer = this.itemOsForm.controls["professional"].value
                    ? this.itemOsForm.controls["professional"].value.id
                    : "";
            }
        }
        if (this.insurance.id != undefined) {
            this.attendanceListProvider
                .getProcedureByInsurance(
                    this.insurance.id,
                    performer ? performer : "",
                    this.order.companyCostCenter.company.id,
                    this.procedurePageOptions
                )
                .then((res) => {
                    this.procedureList = res.body.content;
                });
        }
    }

    getSpeciality(performer) {
        this.attendanceListProvider
            .getSpeciality(
                performer.professional.id,
                this.specialityPageOptions
            )
            .then((res) => {
                this.specialistyList = res.body.content;
                if (!this.orderItem.id) {
                    this.itemOsForm.controls.speciality.setValue(
                        this.specialistyList[0]
                    );
                }
            });
    }

    defaultValues() {
        if (!this.orderItem?.id) {
            this.itemOsForm.controls["quantity"].setValue(1);
            this.itemOsForm.controls["professional"].setValue(
                this.order.mainPerformer
            );
            if (
                this.order.mainOrderItem &&
                this.order.mainOrderItem.professional
            ) {
                this.itemOsForm.controls["profissionalRequest"].setValue(
                    this.order.mainOrderItem.professional
                );
                this.setSolic(this?.order?.mainOrderItem?.professional);
                console.log(this.order);
                this.itemOsForm.controls["firm"].setValue(this.order?.mainOrderItem?.firm);
            }
            this.getSpeciality(this.order.mainPerformer);
        }
    }

    handleProcedureSelected(id, accreditationId) {
        this.gw
            .get(
                `insurance/${this.insurance.id}/company/${this.order.companyCostCenter.company.id}/procedure/${id}`
            )
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((res) => {
                this.itemOsForm.controls["procedureValue"].setValue(
                    res.body.value
                );
                this.itemOsForm.controls["procedureCode"].setValue(
                    res.body.code
                );
            });

        this.getMaMet(id);

        this.checkParameterAccreditation(accreditationId);
    }

    changeTypeItem(event) {
        this.isProcedure = event.value == "1";
    }

    checkParameterAccreditation(id) {
        const names = [
            ParameterNameEnum.ACCREDITATION_PROFESSIONAL_SOLIC,
            ParameterNameEnum.VIA_ACCESS_ACCREDITATION
        ];
        this.getParameterValueByNames(names, id || "");
    }

    action(action) {
        this.progress = true;

        switch (action) {
            case "back":
                this.emitAction.emit(action);
                this.accreditationKitList = [];
                this.kitOrderItem = [];

                // this.attendanceMaterial.setAccreditationProcedureKit(this.kitOrderItem, this.insurance);
                break;

            case "cancel":
                this.actionString = "Cancelando";
                this.emitAction.emit("back");
                break;

            case "new":
                this.actionString = "Novo Item";
                setTimeout(() => {
                    this.itemOsForm = this.createItemOsForm();
                    this.dadosAdicionaisForm = this.createDadosAdicionaisForm();
                    this.orderItem = new OrderItem();
                    this.emitAction.emit(action);
                    this.defaultValues();
                    this.setItemOs();
                    this.destroyAndRecreateComponent();
                    this.progress = false;
                    this.emitAction.emit("SAVE_ITEM_CLOSED");
                }, 2000);
                break;
            default:
                this.progress = false;
                this.emitAction.emit("SAVE_ITEM_CLOSED");
                break;
        }
    }
    checkFields(orderItem: Partial<OrderItem>) {
        let check = true;

        if (
            orderItem.orderItemAuxiliaryList &&
            orderItem.orderItemAuxiliaryList.length > 0
        ) {
            orderItem.orderItemAuxiliaryList.forEach((kit) => {
                if (!kit.performer) {
                    this.snackBar.warnMessage(
                        "Auxiliar sem o Profissonal Informando!"
                    );
                    check = false;
                }
            });
        }


        if (!orderItem.procedure?.id) {
            this.snackBar.warnMessage("Selecione um procedimento válido.")
            check = false;
        }

        return check;
    }

    submitForm() {
        if (this.progress == true) {
            return;
        }
        this.actionString = "Salvando";
        this.progress = true;
        this.emitAction.emit("SAVE_ITEM")
        let orderItem: Partial<OrderItem> = null;
        if (this.isProcedure) {
            orderItem = this.createOrderItemProcedure();

            if (!orderItem?.firm?.id) {
                delete orderItem.firm;
            }
            const dadosAdicionaisValue = this.dadosAdicionaisForm.value;
            let objectsNulls = Object.values(dadosAdicionaisValue).every(
                (value) => value != null
            );
            if (objectsNulls === false) {
                let orderItemTiss: OrderItemTiss = {};
                orderItemTiss = new OrderItemTiss();
                orderItemTiss.viaAdministration = CwUtils.extractId(
                    dadosAdicionaisValue.viaAdministration
                );
                orderItemTiss.viaAccess = CwUtils.extractId(
                    dadosAdicionaisValue.viaAccess
                );
                orderItemTiss.technique = dadosAdicionaisValue.technique;
                orderItemTiss.orderItem = dadosAdicionaisValue.orderItem;
                orderItemTiss.id = dadosAdicionaisValue.id;
                orderItemTiss.token = dadosAdicionaisValue.token;
                orderItemTiss.location = dadosAdicionaisValue.location;
                orderItemTiss.nightShift = dadosAdicionaisValue.nightShift;
                orderItemTiss.reductionAddition =
                    dadosAdicionaisValue.reductionAddition;
                if (
                    CwUtils.checkStringIsNotNull(orderItemTiss.token) &&
                    !CwUtils.checkStringIsNotNull(dadosAdicionaisValue.tokenStatus)
                ) {
                    orderItemTiss.tokenStatus = "9";
                } else {
                    orderItemTiss.tokenStatus =
                        dadosAdicionaisValue.tokenStatus;
                }
                orderItemTiss.degreeParticipation = CwUtils.extractId(
                    dadosAdicionaisValue.degreeParticipation
                ) as DegreeParticipation;
                orderItem.orderItemTiss = orderItemTiss;
            }
            if (orderItem.professionalAnesthetist.id == null) {
                orderItem.professionalAnesthetist = null;
            }
            if (orderItem.performerAccredited.id == null) {
                orderItem.performerAccredited = null;
            }
            if (orderItem.speciality.id == null) {
                orderItem.speciality = null;
            }
            if (orderItem.professional.id == null) {
                orderItem.professional = null;
            }
            if (
                this.session &&
                this.session.quantity > 1 &&
                this.session.frequency != null
            ) {
                orderItem.session = this.session;
            } else {
                delete orderItem.session;
            }
        } else {
            orderItem = this.createOrderItemNotProcedure();
        }

        if (!this.checkFields(orderItem)) {
            this.progress = false;
            this.emitAction.emit("SAVE_ITEM_CLOSED");
            return;
        }
        orderItem.discountType = this.type ? this.type : "1";

        if (this.orderItem && this.orderItem.id) {
            orderItem.id = this.orderItem.id;
            this.attendanceEditProvider
                .editItem(orderItem)
                .then((orderItemUpdate) => {
                    this.progress = false;
                    this.emitAction.emit("SAVE_ITEM_CLOSED");
                    this.emitUpdate.emit(true);
                    this.attendanceMaterial.clear();
                    this.getOrderItemId();
                })
                .catch((error) => {
                    this.progress = false;
                    this.emitAction.emit("SAVE_ITEM_CLOSED");
                    //this.setItemOs()
                });

            return false;
        }

        this.attendanceEditProvider.inserItem(orderItem).then((res) => {
            this.emitUpdate.emit(true);
            this.action("back");
        });
        setTimeout(() => {
            this.progress = false;
            this.emitAction.emit("SAVE_ITEM_CLOSED");
        }, 3000);
    }

    private createOrderItemProcedure(): Partial<OrderItem> {
        const formValue = this.itemOsForm.getRawValue();

        const discountType = "1";

        if (this.auxiliaryList.length > 0) {
            this.orderItemAuxiliaryList = this.auxiliaryList.map((a) => {
                a.performerAccredited = CwUtils.extractId(
                    a.performerAccredited
                );
                a.performer = CwUtils.extractId(a.performer);
                return a;
            });
        }

        let orderItemProductList = this.materialKitList
            .concat(this.drugKitList)
            .concat(this.opmeKitList);

        return {
            order: {
                id: this.order.id,
            },
            procedure: formValue.description,
            performer: {
                id: formValue.professional ? formValue.professional.id : null,
            },
            firm: {
                id: formValue.firm ? formValue.firm.id : null,
            },
            performerAccredited: {
                id: formValue.credentiatedProfessional
                    ? formValue.credentiatedProfessional.id
                    : null,
            },
            speciality: {
                id: formValue.speciality ? formValue.speciality.id : null,
            },
            professional: {
                id: formValue.profissionalRequest
                    ? formValue.profissionalRequest.id
                    : null,
            },
            professionalAnesthetist: {
                id: formValue.professionalAnesthetist
                    ? formValue.professionalAnesthetist.id
                    : null,
            },
            value: formValue.procedureValue,
            quantity: formValue.quantity,
            examDate: moment().format("YYYY-MM-DD"),
            date:
                typeof formValue.dateItemOs !== "string"
                    ? CwUtils.formatDate(
                        CwUtils.momentToDate(formValue.dateItemOs)
                    )
                    : formValue.dateItemOs,
            hour: formValue.hour,
            hourend: formValue.hourend,
            discount: formValue.discount,
            discountType: discountType,
            orderItemFeeList: this.orderItemFeeList,
            orderItemProductList: orderItemProductList,
            orderItemAuxiliaryList: this.orderItemAuxiliaryList,
            sequence: this.orderItem.sequence,
        };
    }

    private createOrderItemNotProcedure(): Partial<OrderItem> {
        const formValue = this.itemOsForm.value;

        return {
            name: formValue.description,
            code: formValue.procedureCode,
            examDate: formValue.dateItemOs,
            date: formValue.dateItemOs,
            hour: formValue.hour,
            hourend: formValue.hourend,
            quantity: formValue.quantity,
            value: formValue.procedureValue,
            professional: {
                id: formValue.credentiatedProfessional.id,
            },
        };
    }

    setSolic(solic) {
        if (solic != null && solic.staff != null) {
            this.tipoSolicitante = solic.staff ? "Interno" : "Externo";
            this.itemOsForm.controls["tipoSolicitante"].setValue(
                solic.staff ? "Interno" : "Externo"
            );
        }

        if (solic != null && solic.firm != null && !this.orderItem.id) {
            this.itemOsForm.controls["firm"].setValue(solic.firm);
        }
    }

    setKitList(kitListEvent, type) {
        switch (type) {
            case "F":
                this.orderItemFeeList = kitListEvent;
                break;
            case "M":
                this.materialKitList = kitListEvent;
                break;
            case "D":
                this.drugKitList = kitListEvent;
                break;
            case "O":
                this.opmeKitList = kitListEvent;
                break;
            case "A":
                this.auxiliaryList = kitListEvent;
                break;
        }

        this.kitList = new Array();
    }

    getSession(event) {
        this.session = event;
    }

    checkArrayNull(kitListEvent, type) {
        if (!kitListEvent) {
            return;
        }

        if (type == "F") {
            kitListEvent.forEach((kit) => {
                // kit.fee = kit.fee.fee;
            });
            this.orderItemFeeList = kitListEvent;
        } else if (type == "M") {
            kitListEvent.forEach((kit) => {
                delete kit.accreditation;
                delete kit.auxiliaryList;
                delete kit.fee;
                delete kit.procedure;
                delete kit.auxiliary;
            });
            this.orderItemProductList = kitListEvent;
        } else if (type == "D") {
            this.orderItemProductListM = kitListEvent;
        } else if (type == "A") {
            kitListEvent.forEach((kit) => {
                if (kit.auxiliary.auxiliary) {
                    const auxiliary = kit.auxiliary.auxiliary;
                    delete kit.auxiliary;

                    kit.auxiliary = auxiliary;
                }
                delete kit.performer.performer;
                delete kit.performer.active;
                delete kit.performer.council;
                delete kit.performer.councilNumber;
                delete kit.performer.councilType;
                delete kit.performer.participationList;
                delete kit.performer.firm;
                delete kit.performer.specialityList;
                delete kit.performer.staff;
                delete kit.performer.state;
                delete kit.performer.speciality;
                delete kit.performer.person;
                delete kit.auxiliary.degreeParticipation;
                this.orderItemAuxiliaryList.push(kit);
            });
        }
    }

    getMaMet(procedureId?) {
        if (this.orderItem.id) {
            return;
        }
        this.feeAccreditationList = [];
        this.orderItemFeeList = [];
        this.materialKitList = [];
        this.drugKitList = [];
        this.opmeKitList = [];
        this.auxiliaryList = [];
        this.orderItemAuxiliaryList = [];
        this.orderItemProductList = [];
        this.actionString = "Verificando kit";
        this.progress = true;
        this.attendanceListProvider
            .getMatMed(
                procedureId,
                this._insurance.id,
                this.order.companyCostCenter.company.id
            )
            .then((res: any) => {
                this.accreditationKitList = res.body;
                if (this.kitOrderItem.length == 0) {
                    this.attendanceMaterial.setAccreditationProcedureKit(
                        this.accreditationKitList,
                        this.insurance
                    );
                }
                /*this.accreditationKitList = this.accreditationKitList.map(kit => {
                kit.readOnly = true
                return kit;
            });*/

                if (!this.kitList.length) {
                    this.accreditationKitList.forEach((kit) => {
                        this.kitList.push(kit);
                    });
                }
                this.progress = false;
                this.emitAction.emit("SAVE_ITEM_CLOSED");
            })
            .catch((err) => {
                this.progress = false;
                this.emitAction.emit("SAVE_ITEM_CLOSED");
            });
        this.progress = false;
        this.emitAction.emit("SAVE_ITEM_CLOSED");
    }

    getViaAccess() {
        this.attendanceListProvider.getViaAccess().then((res: any) => {
            this.viaAccess = res.body;
        });
    }

    getViaAdministration() {
        this.attendanceListProvider.getViaAdministration().then((res: any) => {
            this.viaAdministration = res.body;
        });
    }

    getState(state) {
        let result = "";
        switch (state) {
            case "N":
                result = "Normal";
                break;
            case "B":
                result = "Bloqueada";
                break;
            case "P":
                result = "Pendente";
                break;
            default:
                break;
        }
        return result;
    }

    getStatus(status) {
        let result = "";
        switch (status) {
            case "1":
                result = "Aberta";
                break;
            case "2":
                // this.blockform();
                result = "Fechada";
                break;

            default:
                break;
        }
        return result;
    }

    blockform() {
        this.itemOsForm.disable();
        this.itemOsForm.controls["speciality"].enable();
        this.itemOsForm.controls["profissionalRequest"].enable();
    }

    checkStatus() {
        const status = this.getStatus(this.order.status);
        if (status === "Aberta") {
            return true;
        } else {
            return false;
        }
    }

    registrationSolic() {
        this.solicRegistrationDialogRef = this.dialog.open(
            QuickRegistrationSolicComponent,
            {
                panelClass: "quick-registation-solic",
                data: this.order,
                disableClose: false,
            }
        );

        this.solicRegistrationDialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.itemOsForm.controls["profissionalRequest"].setValue(
                    result
                );
                this.setSolic(result);
            }
        });
    }

    changeType(type: string) {
        this.type = type;
    }

    destroyAndRecreateComponent() {
        this.attendanceMaterial.clear();
        this.showAttendanceMaterial = false;

        // Aguarde um breve momento para garantir que o componente seja destruído
        setTimeout(() => {
            this.showAttendanceMaterial = true;
            setTimeout(() => {
                this.initKite();
            }, 500);
        }, 300);
    }
}
